export const FLUID_INPUT_TYPES = [
  'Normal Saline 0.9%',
  'Dextrose 5%',
  'Hartmann Solution',
  'Blood Product',
  'Other',
];

export const FLUID_OUTPUT_TYPES = [
  'Urine',
  'Drain',
  'Nasogastric',
  'Vomiting',
  'Other',
];

export const OBSERVATION_ENTRY_TYPES = {
  observation: { label: 'Nursing observation', dotClass: 'bg-primary' },
  physician: { label: 'Physician notified', dotClass: 'bg-primary' },
  intervention: { label: 'Intervention performed', dotClass: 'bg-primary' },
  incident: { label: 'Incident or deterioration', dotClass: 'bg-primary' },
};

export const FLOW_SHEET_SECTIONS = {
  vitals: { title: 'Vitals', headerClass: 'text-primary border-primary/30 bg-primary-light' },
  fluids: { title: 'Fluid Balance', headerClass: 'text-primary border-primary/30 bg-primary-light' },
  medications: { title: 'Medications Log', headerClass: 'text-primary border-primary/30 bg-primary-light' },
  observations: { title: 'Interventions & Observations', headerClass: 'text-primary border-primary/30 bg-primary-light' },
};

export const HIGH_ALERT_DRUGS = [
  'insulin',
  'heparin',
  'warfarin',
  'enoxaparin',
  'digoxin',
  'furosemide',
  'potassium chloride',
  'morphine',
  'amiodarone',
  'potassium',
];

export function isHighAlertDrug(name) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return HIGH_ALERT_DRUGS.some((d) => lower.includes(d));
}

export function nowTimeString() {
  return new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
}
